/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsgroupchats2Inputs */

const en_statsgroupchats2 = /** @type {(inputs: Statsgroupchats2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With group chat`)
};

const de_statsgroupchats2 = /** @type {(inputs: Statsgroupchats2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Gruppenchat`)
};

/**
* | output |
* | --- |
* | "With group chat" |
*
* @param {Statsgroupchats2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsgroupchats2 = /** @type {((inputs?: Statsgroupchats2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsgroupchats2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsgroupchats2(inputs)
	return de_statsgroupchats2(inputs)
});
export { statsgroupchats2 as "statsGroupChats" }